import DurationType from '@v/inventory/products/edit/models/DurationType.js'

export const isDurationGreaterThanGivenDuration = givenDuration => value => {
  return givenDuration !== null && value !== null
    ? durationStringToSeconds(givenDuration) <= durationStringToSeconds(value)
    : true
}

export const fitsInDuration = maximumDuration => value => {
  return value !== null && maximumDuration !== null
    ? durationStringToSeconds(value) <= durationStringToSeconds(maximumDuration)
    : true
}

export const isResetTimeAllowed = durationType => value =>
  value === null ||
  !(durationType === DurationType.NoDuration || durationType === DurationType.ParallelScheduling)

// thanks to https://stackoverflow.com/questions/14934089/convert-iso-8601-duration-with-javascript/54100940#54100940
const durationStringToSeconds = durationString => {
  const stringPattern = /^PT(?:(\d+)D)?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d{1,3})?)S)?$/
  const stringParts = stringPattern.exec(durationString)
  return (
    (((stringParts[1] === undefined ? 0 : stringParts[1] * 1) /* Days */ * 24 +
      (stringParts[2] === undefined ? 0 : stringParts[2] * 1)) /* Hours */ *
      60 +
      (stringParts[3] === undefined ? 0 : stringParts[3] * 1)) /* Minutes */ *
      60 +
    (stringParts[4] === undefined ? 0 : stringParts[4] * 1) /* Seconds */
  )
}
